import Styles from './index.module.scss'
import React, {useState} from "react";
const MyCollectionsModal = ({ onClose, data }) => {

  const handleClick = () => {
    onClose && onClose();
  }

  return (
    <div className={Styles.cupCollectionModal}>
      <div className={Styles.cupOuter}>
        <div className={Styles.title}>我的藏品</div>
        <div className={Styles.content}>
          <div className={Styles.tableRow} style={{ marginBottom: '0.5rem'}}>
            <div className={Styles.column1}></div>
            <div className={`${Styles.column2} ${Styles.tableTitle}`}>名称</div>
            <div className={`${Styles.column3} ${Styles.tableTitle}`}>数量</div>
          </div>
          {data && Object.keys(data).map((groupName, index) => {
            return (
              <div key={index} className={Styles.groupBox}>
                {data[groupName] && data[groupName].map((subItem, subIndex) => {
                  return (
                    <div key={subIndex} className={Styles.tableRow}>
                      <div className={Styles.column1}>{subIndex === 0 ? `${groupName?.toUpperCase()}组`: ''}</div>
                      <div className={Styles.column2}>{subItem?.code}（{subItem.name}）</div>
                      <div className={Styles.column3}>{subItem.count}</div>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div className={Styles.btn} onClick={handleClick}>我知道了</div>
      </div>
    </div>
  )
}
export default MyCollectionsModal